module.exports = __webpack_public_path__ + "img/大图4.74486571.jpg";